import React, { useEffect, useRef, useState } from 'react';
import { Chart, Coord, Axis, Geom, Tooltip, Guide } from 'bizcharts';
import { KPITitleText, KpiSubText } from '../globalStyling/styledText';

const DonutChart = ({
  axisName = 'value',
  position = 'counts',
  showTooltip = false,
  chartData = [{ value: 'Placeholder', counts: 10, color: 'Blue' }],
  height = 300,
  totalCount,
  showCenterText = false,
  centerText = 'Transactions',
}) => {
  const containerRef = useRef(null);
  const [fontSize, setFontSize] = useState({ title: 12, value: 20 });

  useEffect(() => {
    const updateFontSize = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const titleSize = Math.max(10, Math.min(14, containerWidth * 0.04));
        const valueSize = Math.max(14, Math.min(24, containerWidth * 0.07));
        setFontSize({ title: titleSize, value: valueSize });
      }
    };

    updateFontSize();
    window.addEventListener('resize', updateFontSize);
    return () => window.removeEventListener('resize', updateFontSize);
  }, []);

  const cols = {
    percent: {
      formatter: (val) => {
        val = (val / totalCount) * 100;
        return `${val.toFixed(2)}%`;
      },
    },
    counts: {
      formatter: (val) => {
        const percentage = totalCount ? `(${((val / totalCount) * 100).toFixed(2)}%)` : '';
        return `${val.toLocaleString()} ${percentage}`;
      },
    },
  };

  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        height: height,
        width: '100%',
        minHeight: '200px',
      }}
    >
      <Chart
        forceFit
        data={chartData}
        padding="auto"
        height={height}
        scale={cols}
      >
        <Coord type="theta" radius={0.75} innerRadius={0.65} />
        <Axis name={axisName} />
        {showTooltip && <Tooltip showTitle={false} />}
        <Geom
          color={[
            axisName,
            (value) => {
              const index = chartData.findIndex((el) => el[axisName] === value);
              return index >= 0 ? chartData[index].color : 'black';
            },
          ]}
          position={position}
          type="intervalStack"
        />
        {showCenterText && centerText && (
          <Guide>
            <Guide.Html
              position={['50%', '50%']}
              html={`<div style="text-align:center;white-space:nowrap;">
                <div style="font-size:${fontSize.title}px;color:#636363;line-height:1.2;">${centerText}</div>
                <div style="font-size:${fontSize.value}px;font-weight:700;color:#333;line-height:1.2;">${totalCount ? totalCount.toLocaleString() : 0}</div>
              </div>`}
              alignX="middle"
              alignY="middle"
            />
          </Guide>
        )}
      </Chart>
    </div>
  );
};

export default DonutChart;
